import { defineStore } from "pinia";
import { useLoadingState } from "@polargold/pg-frontend-vue";

export const useGlobalLoadingStore = defineStore("globalLoadingStore", () => {
    const {
        isLoading,
        activateLoadingState: showLoadingScreen,
        deactivateLoadingState: hideLoadingScreen,
    } = useLoadingState(true);

    /**
     * Bugfix: the original implementation called `callback()` without awaiting it, so
     * `hideLoadingScreen()` fired immediately for an async callback instead of after it
     * actually finished (e.g. `RestrictedViews.vue`'s auth-redirect check). Now properly
     * awaited, so the loading screen stays up for the real duration of async work.
     */
    const initialize = async (callback?: () => void | Promise<void>) => {
        await showLoadingScreen();

        if (callback) {
            await callback();
        }

        await hideLoadingScreen();
    };

    return {
        showLoadingScreen,
        hideLoadingScreen,
        initialize,
        isLoading
    };
});
